const API_URL =
  (import.meta.env.VITE_API_URL as string | undefined) ?? "http://localhost:8000";

export type LeadPayload = {
  name: string;
  email: string;
  company?: string;
  project_type: string;
  budget: string;
  timeline?: string;
  message: string;
  source?: string;
  /** honeypot — must be empty */
  website?: string;
};

export type LeadResponse = {
  id: string;
  created_at: string;
};

export async function submitLead(payload: LeadPayload): Promise<LeadResponse> {
  const res = await fetch(`${API_URL}/api/leads`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try {
      const data = await res.json();
      detail = data.detail ?? detail;
    } catch {
      /* ignore */
    }
    throw new Error(detail);
  }
  return res.json();
}

export type PublicProject = {
  id: string;
  title: string;
  url: string;
  iframeSrc: string;
  client: string;
  stack: string[];
  notes: string;
};

export async function fetchProjects(): Promise<PublicProject[]> {
  const res = await fetch(`${API_URL}/api/projects`);
  if (!res.ok) throw new Error(`Failed to load projects (${res.status}).`);
  return res.json();
}
